export const name = 'waitForApplyDialogController';
export default function waitForApplyDialogController($scope, $log, $mdDialog, $timeout, templatesService) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    var vm = this;
    vm.updating = true;
    vm.successfullyUpdated=false;
    vm.failedUpdated=false;
    vm.updatedPreset = null;
    vm.close = close;

    applyChanges();

    function applyChanges(){
        let startTime = new Date().getMilliseconds();
        templatesService.updateTemplate(vm.updatedValues).then(
            function(updatedPreset){
                vm.updatedPreset = updatedPreset;
                let timePassed = new Date().getMilliseconds() - startTime;
                if(timePassed < 2000){
                  $timeout(()=>{
                    vm.updating = false;
                    $mdDialog.hide(updatedPreset);
                  }, 2000 - timePassed);
                }else{
                  vm.updating = false;
                  $mdDialog.hide(updatedPreset);
                }
            },
            function(error){
                vm.updating = false;
                vm.failedUpdated = true;
            }
        );
    }

    function close(){
        $mdDialog.cancel();
    }
}
